import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { parseDate } from '@internationalized/date';
import { selectDateRange, selectSelectedPlant, selectFilterDate } from '@pages/reporting-pages/redated-orders/store/selectors';
import { setDateRange, setSelectedPlant, setFilterDate } from '@pages/reporting-pages/redated-orders/store/slice';
import { useGetPlantsListQuery } from '@api/list-data/api';
import { DateRangePicker } from 'components/date-picker/DateRangePicker';
import { Select } from 'components/select/Select';
import { ComboBox } from 'components/select/ComboBox';
import { ListBoxItem } from 'react-aria-components';
import { RedatedTypeEnum } from '@api/order-reporting/types/RedatedParams';
import { DateRange } from '@project-types/DateRange';



const ParamsToolbar = () => {

	const dateRange = useSelector(selectDateRange);
	const selectedPlant = useSelector(selectSelectedPlant);
	const filterDate = useSelector(selectFilterDate);

	const dispatch = useDispatch();
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));
	const updateSelectedPlant = (value: string | null) => dispatch(setSelectedPlant(value));
	const updateFilterDate = (value: string | null) => dispatch(setFilterDate(value));

	const { data, isLoading, isFetching, isError } = useGetPlantsListQuery({ userId: 'any' });

	return (
		<div className='reporting-params-toolbar redated-orders-toolbar'>

			<DateRangePicker
				label='Od - Do'
				isRequired={true}
				value={
					dateRange
					? { start: parseDate(dateRange.from), end: parseDate(dateRange.to) }
					: null
				}
				onChange={(rangeValue) => {
					if (rangeValue) {
						updateDateRange({
							from: rangeValue.start.toString(),
							to: rangeValue.end.toString(),
						});
					}
				}}
			/>

			<Select
				label='Typ'
				selectedKey={filterDate ? filterDate : ''}
				items={[
					{ id: '', text: 'Všechny' },
					{ id: RedatedTypeEnum.incoming, text: 'Příchozí' },
					{ id: RedatedTypeEnum.outgoing, text: 'Odchozí' }
				]}
				onSelectionChange={selected => {
					if (typeof selected === 'string') {
						updateFilterDate(selected ? selected : null)
					}
				}}
			>
				{(item) => <ListBoxItem id={item.id}>{item.text}</ListBoxItem>}
			</Select>

			<ComboBox
				label='Depo'
				defaultItems={data
					? [
						{ id: '', text: 'Všechna depa' },
						...data.toSorted((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
					]
					: []
				}
				isDisabled={isLoading || isFetching}
				errorMessage='Problém při načítání dat'
				isInvalid={isError}
				selectedKey={selectedPlant ? selectedPlant : ''}
				onSelectionChange={selected => {
					if (typeof selected === 'string') {
						updateSelectedPlant(selected);
					}
				}}
			>
				{(item) => <ListBoxItem id={item.id}>{item.text}</ListBoxItem>}
			</ComboBox>

		</div>
	)
};

export default memo(ParamsToolbar);